<button mat-stroked-button
        [color]="'primary'"
        (click)="handleNavigateOneLevelBack()">
  <div class="button-content">
    <i class="icon icon--arrow-left icon--color--broker icon--size--20 mr--1"></i>
    {{ 'page.back_action' | translate }}
  </div>
</button>
